export const SoldPill = () => {
    return (
        <div className='flex justify-center w-[120px] px-2 rounded bg-red-700 text-white'>
            Sold
        </div>
    )
}